import { StudentEnroll } from '../../model/student-enroll';

export class StudentList {
    constructor(
        public studentIds: string[],
        public enroll?: StudentEnroll,
        public schoolEntryDate?: Date
    ) {}
}
